<template>
    <div>
        <h1>Пользователи</h1>
        
        <div class="blue-grey lighten-5 z-depth-1">
            <div class="row">
                <div class="input-field col s6">
                    <input type="datetime-local" v-model="createdAtFrom">
                    <span class="helper-text">
                        Зарегистированы с <strong v-if="createdAtFrom">{{createdAtFrom | notificationDateFormat}}</strong>
                    </span>
                </div>
                <div class="input-field col s6">
                    <input type="datetime-local" v-model="createdAtTo">
                    <span class="helper-text">
                        по <strong v-if="createdAtTo">{{createdAtTo | notificationDateFormat}}</strong>
                    </span>
                </div>
            </div>
        </div>

        <nav class="blue-grey lighten-5">
            <div class="nav-wrapper">
                <Search v-model="search"/>
            </div>
        </nav>

        <div class="card-panel blue-grey lighten-5 checkbox-filters" style="margin-top:20px;">
            <label>
                <input type="checkbox" v-model="isVkGroupSub">
                <span>Подписаны на группу</span>
            </label>
            <label>
                <input type="checkbox" v-model="isEmailVerified">
                <span>Подтвердили email</span>
            </label>
            <label>
                <input type="checkbox" v-model="isOldLogin">
                <span>Были зареганы до обновы</span>
            </label>
            <label>
                <input type="checkbox" v-model="isBanned">
                <span>Забанены</span>
            </label>
            <label>
                <input type="checkbox" v-model="isSubstrateChanged">
                <span>Сменили подложку</span>
            </label>
            <label>
                <input type="checkbox" v-model="sortByLastVisited">
                <span>Соритровать по убывнию даты последнего визита</span>
            </label>
        </div>

        Всего: {{total}}

        <list 
            :urlString='`/users`'
            itemsClasses='collection'
            itemClasses='collection-item avatar'
            :itemComponent='AllUsersItem'
            :limit='10'
            :queryParams='{
                search: search || undefined,
                createdAtFrom,
                createdAtTo,
                isVkGroupSub,
                isEmailVerified,
                isOldLogin,
                isBanned,
                isSubstrateChanged,
                sortByLastVisited
            }'
        >
        </list>
    </div>
</template>

<script>
import List from '@/components/basic/List.vue'
import Search from '@/components/basic/Search.vue'

export default {
    components: { List, Search },
    data:() => ({
        total: 0,
        usersList: [],
        AllUsersItem: () => import(`@/components/profile/AllUsersItem.vue`),
        search: '',
        createdAtFrom: undefined,
        createdAtTo: undefined,
        isVkGroupSub: undefined,
        isEmailVerified: undefined,
        isOldLogin: undefined,
        isBanned: undefined,
        isSubstrateChanged: undefined,
        sortByLastVisited: undefined
    }),
    sockets:{
        setUsersListTotal: function(val){
            this.total = val
        },
    },
}
</script>

<style scoped>
    .checkbox-filters label{
        margin-right:20px;
    }
</style>